import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { GripVertical } from 'lucide-react';

function DraggableCard({ id, children, size = 'half' }) {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
    position: 'relative',
  };

  // Grid span based on size
  const sizeClass = `dashboard-card dashboard-card-${size}`;

  return (
    <div
      ref={setNodeRef}
      style={style}
      className={`${sizeClass} ${isDragging ? 'dashboard-card-dragging' : ''}`}
    >
      <div
        className="dashboard-card-drag-handle"
        {...attributes}
        {...listeners}
        aria-label={`Drag to reorder. Use arrow keys to move.`}
      >
        <GripVertical size={16} />
      </div>
      {children}
    </div>
  );
}

export default DraggableCard;
